module.exports = __webpack_public_path__ + "img/EARRING.7f148900.webp";